
import { useQuery } from '@tanstack/react-query';
import { useUser } from '@/contexts/UserContext';
import { profileService } from '@/services/profile';
import { USER_PROFILE, getEntityKey } from '@/constants/queryKeys';
import { toast } from 'sonner';

/**
 * Hook to fetch and cache the user's profile information
 * Note: This hook only fetches existing profiles, it does not create them.
 * Profile creation happens during registration via database trigger.
 */
export const useUserProfile = () => {
  const { user, isLoading: authLoading } = useUser();
  
  const {
    data: profile,
    isLoading,
    error,
    refetch
  } = useQuery({
    queryKey: getEntityKey(USER_PROFILE, user?.id),
    queryFn: async () => {
      if (!user?.id) {
        console.log('No user ID available');
        return null;
      }
      
      console.log('Fetching profile for user:', user.id);
      
      try {
        // Fetch the existing profile - do not create if missing
        const existingProfile = await profileService.getUserProfile(user.id);
        
        if (!existingProfile) {
          console.log('No profile found for user:', user.id);
          return null;
        }
        
        console.log('Profile found:', existingProfile);
        
        
        return existingProfile;
      } catch (err) {
        console.error('Error in useUserProfile queryFn:', err);
        throw err;
      }
    },
    enabled: !!user?.id && !authLoading,
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: 2, // Retry twice on failure
    meta: {
      onError: (error) => {
        console.error('Query error in useUserProfile:', error);
        toast.error('Error loading profile. Please try again.');
      }
    }
  });

  return {
    profile,
    isLoading: isLoading || authLoading,
    error: error ? String(error) : null,
    refetchProfile: refetch
  };
};
